import PageNavigation from './PageNavigation';

export default PageNavigation;
